<script lang="ts">
  import { onMount } from "svelte";
  import DataForm from "../../lib/dataform/DataForm.svelte";
  import { type JSONObject } from "../../lib/dataform/dataFormLib.svelte";
  import HiddenInput from "../../lib/dataform/HiddenInput.svelte";
  import Trash from "~icons/ph/trash";
  import revert from "../../stores/revert";

  let {
    class:className=""
  } = $props();

  let value = $state<JSONObject>({});
  let dataForm = $state<DataForm>();

  const remove = ()=>dataForm?.remove();

  // `address` is for display only; all other fields are to be stored
  let hiddenFields = $derived(Object.keys(value).filter(k=>k != "address"));

  const highlighted = revert(null, 500);
  onMount(() => { if (!value?.id) highlighted.set(true) });
</script>

<DataForm bind:value bind:this={dataForm}>
  <div
    class="flex justify-between items-start gap-2 border rounded-lg p-4 {className}
    {$highlighted ? 'border-blue-600 shadow transition-none' : 'transition-[border-color,box-shadow] duration-1000'}"
  >
      <span>{value.address}</span>
      {#each hiddenFields as name}
        <HiddenInput {name} />
      {/each}
    <button onclick={remove} type="button" class="text-blue-600 -mt-0.2">
      <Trash class="h-6 w-6 shrink-0" />
    </button>
  </div>
</DataForm>
